const defaultInputProps = {
  type: "input",
  inputType: "text",
};

export const fieldUser = [
  // {
  //   id: "customerId",
  //   name: "customerId",
  //   label: "Customer Id",
  //   disabled: true,
  //   errorMessage: "customer id",
  // },
  // {
  //   id: "buildingId",
  //   name: "buildingId",
  //   label: "Building Id",
  //   disabled: true,
  //   errorMessage: "building id",
  // },
  {
    id: "userName",
    name: "userName",
    label: "User Name",
    disabled: true,
    errorMessage: "user name",
  },
  {
    id: "accountType",
    name: "accountType",
    label: "Account Type",
    disabled: true,
    errorMessage: "account type",
  },
  {
    id: "firstName",
    name: "firstName",
    label: "First Name",
    errorMessage: "first name",
    disabled: true,
  },
  {
    id: "lastName",
    name: "lastName",
    label: "Last Name",
    errorMessage: "last name",
    disabled: true,
  },
  {
    id: "phoneNumber",
    name: "phoneNumber",
    label: "Phone Number",
    errorMessage: "phone number",
  },
  {
    id: "email",
    name: "email",
    label: "Email",
    disabled: true,
    errorMessage: "email",
  },
].map((field) => ({
  ...defaultInputProps,
  ...field,
}));
